module.exports = __webpack_public_path__ + "static/media/Slide6.a4f95ba1.JPG";